module.exports = __webpack_public_path__ + "img/dwn.f41e7c9d.svg";